const firebaseConfig = {
    apiKey: "AIzaSyAIEE5j5cZFWm8gnRTY5ZiVBhT7AoBLndw",
    authDomain: "maa-o-sishu-hosptal.firebaseapp.com",
    projectId: "maa-o-sishu-hosptal",
    storageBucket: "maa-o-sishu-hosptal.appspot.com",
    messagingSenderId: "382133840226",
    appId: "1:382133840226:web:570192db0457a06c8d243b"
  };
  export default firebaseConfig;